import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function EditOrder (){
  const {user} = useUser()
  let view = contentLayout[modules.EditOrder]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.EditOrder.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.EditOrder}></Index>
 )
}

export default EditOrder
